import * as Yup from "yup";

const validationDefault = {
  name: Yup.string().required("Nome é obrigatório"),
  purchaseTypeId: Yup.number()
    .typeError("Tipo de estoque obrigatório")
    .required("Tipo de estoque obrigatório"),
  category: Yup.number()
    .typeError("Categoria é obrigatório")
    .required("Categoria é obrigatório"),
  subCategory: Yup.number()
    .typeError("Subcategoria é obrigatório")
    .required("Subcategoria é obrigatório"),
  status: Yup.string()
    .typeError("Status é obrigatório")
    .required("Status é obrigatório"),
  base64: Yup.string()
    .typeError("Image obrigatória")
    .required("Image obrigatória")
};

export const validationSchemaEdit = Yup.object().shape({
  ...validationDefault
});

export const validationSchemaCreate = Yup.object().shape(validationDefault);
